import { useState } from 'react';

import { useLocalStorage } from 'react-use';

import { getValueFromStorage } from 'utils/storage/storageHelper';

import { useApplicationStats } from './useApplicationStats';

export const APP_STATS_KEYSTROKES = 'app_stats_keystrokes';

export function useTrackKeystrokeNumber(
  trackFn,
  cookieKey = 'ssn_keystroke_count'
) {
  const [keystrokesCount, setKeystrokesCount, clearKeystrokesCount] =
    useLocalStorage(cookieKey, 0);
  const [previousValue, setPreviousValue] = useState('');
  const [, updateApplicationStats] = useApplicationStats(APP_STATS_KEYSTROKES);

  function handleOnChange(value) {
    if (previousValue !== value) {
      setKeystrokesCount(keystrokesCount + 1);
    }
    setPreviousValue(value);
  }

  function trackKeystrokes() {
    const updatedKeystrokeCount = getValueFromStorage(cookieKey);

    trackFn(updatedKeystrokeCount);
    updateApplicationStats(cookieKey, updatedKeystrokeCount);
    clearKeystrokesCount();
  }

  return [trackKeystrokes, handleOnChange];
}
